module.exports = __webpack_public_path__ + "static/dosBicicletasDiferentes-cd6f7e39d2ec7639d524debf81b7ab01.png";